// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Button from 'components/common/Button';
import message from 'antd/lib/message';
// APOLLO
// import { CREATE_QUESTION_TEMPLATE } from '/imports/ui/apollo/mutations';
// import { GET_QUESTION_TEMPLATES } from '/imports/ui/apollo/queries';
import questionTemplatesQuery from 'ApolloClient/Queries/questionTemplates';
import questionsQuery from 'ApolloClient/Queries/questions';
import createQuestionTemplate from 'ApolloClient/Mutations/createQuestionTemplate';
import { graphql, compose } from 'react-apollo';
// COMPONENTS
import FormModal from 'components/common/FormModal';
import QuestionTemplateForm from 'components/forms/QuestionTemplateForm';
// import SubmittingSpinner from '/imports/ui/components/forms/SubmittingSpinner';

export class QuestionTemplateModal extends React.Component {
  state = {
    visible: false,
    title: '',
    selectedQuestions: [],
    step: 1,
  };

  onSubmit = () => {
    if (this.state.loading) {
      return null;
    }

    if (this.state.step === 1) {
      return this.setState({ step: 2, loading: false });
    }

    if (this.state.step === 2) {
      return this.setState({ step: 3, loading: false });
    }

    if (this.state.selectedQuestions.length === 0) {
      return message.error('must select at least one question');
    }

    let params = {
      title: this.state.title,
      questions: this.state.selectedQuestions.map(q => q.value),
    };

    if (this.state.step === 3 && this.state.selectedQuestions.length > 0) {
      this.setState({ loading: true });
      this.props
        .createQuestionTemplate({
          variables: { params },
          refetchQueries: [{ query: questionTemplatesQuery }],
        })
        .then(res => this.onClear())
        .catch(err => this.onClear());
    }
  };

  onToggleModal = () => {
    this.setState({ visible: !this.state.visible });
  };

  onNext = () => {
    if (!this.state.title) {
      return message.error('title is required.');
    }
    this.setState({ step: this.state.step + 1 });
  };

  onCancel = () => {
    this.onClear();
  };

  onClear = () => {
    this.setState({
      visible: false,
      step: 1,
      loading: false,
      title: null,
      selectedQuestions: [],
    });
  };

  onChange = changedValue => {
    console.log(changedValue);
    this.setState(changedValue);
  };

  render() {
    const formComonent = !this.state.loading ? (
      <QuestionTemplateForm
        step={this.state.step}
        title={this.state.title}
        questionOptions={this.props.questionsQuery.questions}
        selectedQuestions={this.state.selectedQuestions}
        onChange={this.onChange}
        loadingQuestions={this.props.questionsQuery.loading}
        {...this.props}
      />
    ) : (
      <div />
    );

    return (
      <React.Fragment>
        <Button
          style={{
            position: 'absolute',
            right: 0,
            top: -7,
            width: 175,
          }}
          onClick={this.onToggleModal}
        >
          + ADD TEMPLATE
        </Button>
        <FormModal
          title="Create a Questionnaire Template"
          visible={this.state.visible}
          onSubmit={this.state.step !== 3 ? this.onNext : this.onSubmit}
          onOk={this.state.step !== 3 ? this.onNext : this.onSubmit}
          okText={this.state.step !== 3 ? 'Next' : 'Submit'}
          onCancel={this.onCancel}
          loading={this.state.loading}
          formComponent={formComonent}
        />
      </React.Fragment>
    );
  }
}

// STYLE
// ==========================================
const s = {
  button: {
    position: 'absolute',
    right: 0,
  },
};

// EXPORT
// ==========================================
export default compose(
  graphql(createQuestionTemplate, { name: 'createQuestionTemplate' }),
  graphql(questionsQuery, { name: 'questionsQuery' }),
)(QuestionTemplateModal);



// WEBPACK FOOTER //
// ./src/routes/app-studio/QuestionTemplatesArea/QuestionTemplateModal/index.js